import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "../lib/auth";
import { PageHeader, Stat } from "../components/ui-ext";
import ExportButton from "../components/ExportButton";

export default function Dashboard() {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/dashboard/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  const role = user.role;
  const eyebrow = { engineer: "Engineer Portal", manager: "Manager Portal", admin: "Admin / HOD Portal" }[role];

  return (
    <div>
      <PageHeader
        eyebrow={eyebrow}
        title={`Welcome, ${user.name.split(" ")[0]}`}
        subtitle={role === "engineer" ? "Track your tasks, expenses, attendance and payments." : "Overview of the entire field operations."}
        right={role !== "engineer" && <ExportButton endpoint="all.xlsx" label="Export All Data" testid="export-all-btn" />}
      />

      {role === "engineer" ? (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <Stat label="My Tasks" value={stats?.my_tasks_total} testid="stat-my-tasks" />
          <Stat label="Open" value={stats?.my_tasks_open} testid="stat-my-tasks-open" />
          <Stat label="Completed" value={stats?.my_tasks_done} testid="stat-my-tasks-done" />
          <Stat label="Attendance Today" value={stats?.attendance_today ? "✓ Checked-in" : "Pending"} testid="stat-attendance" />
          <Stat label="Expenses Submitted" value={stats?.expenses_submitted} testid="stat-exp-submitted" />
          <Stat label="Approved" value={stats?.expenses_approved} testid="stat-exp-approved" />
          <Stat label="Paid" value={stats?.expenses_paid} testid="stat-exp-paid" />
          <Stat label="Leaves Pending" value={stats?.open_leaves} testid="stat-leaves" />
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <Stat label="Engineers" value={stats?.total_engineers} testid="stat-engineers" />
          <Stat label="Projects" value={stats?.total_projects} testid="stat-projects" />
          <Stat label="Total Tasks" value={stats?.total_tasks} testid="stat-tasks" />
          <Stat label="Tasks Open" value={stats?.tasks_open} testid="stat-tasks-open" />
          <Stat label="Tasks Done" value={stats?.tasks_done} testid="stat-tasks-done" />
          <Stat label="Expenses · Manager Q" value={stats?.expenses_pending_manager} testid="stat-exp-mgr" />
          <Stat label="Expenses · HOD Q" value={stats?.expenses_pending_admin} testid="stat-exp-adm" />
          <Stat label="Expenses Paid" value={stats?.expenses_paid_count} testid="stat-exp-paid" />
          <Stat label="Leaves · Manager Q" value={stats?.leaves_pending_manager} testid="stat-lv-mgr" />
          <Stat label="Leaves · HOD Q" value={stats?.leaves_pending_admin} testid="stat-lv-adm" />
          <Stat label="Live Requests" value={stats?.live_requests_open} testid="stat-lr" />
          <Stat label="Unlock Requests" value={stats?.unlock_requests_pending} testid="stat-unlock" />
        </div>
      )}
    </div>
  );
}
